import type {
  CommissionResponse,
  WithdrawSuccessResponse,
} from '@/shared/types';
import { apiClient } from '@/shared/api';
import type { WithdrawCryptoRequestFunction } from '@/features/withdraw-crypto';
import type {
  SendMfaOtpCodeRequestDto,
  SendMfaOtpCodeResponseDto,
} from '@/entities/mfa-identity';

export const getWithdrawCommission = async (
  networkName: string,
  assetCode: string,
  amount: string | number,
  onTop?: boolean
): Promise<CommissionResponse> => {
  const response = await apiClient.get<CommissionResponse>(
    `/operations/crypto/${networkName}/withdraw/commission`,
    {
      params: {
        asset: assetCode,
        amount,
        ontop: onTop,
      },
    }
  );
  return response.data;
};

export const withdrawCrypto: WithdrawCryptoRequestFunction = async ({
  networkName,
  body,
}) => {
  const response = await apiClient.post<WithdrawSuccessResponse>(
    `/operations/crypto/${networkName}/withdraw`,
    body
  );
  return response.data;
};

export const sendWithdrawTwoFactorIdentityCode = async (
  args: SendMfaOtpCodeRequestDto
) => {
  const response = await apiClient.post<SendMfaOtpCodeResponseDto>(
    `/operations/twofa/otp/send`,
    args
  );
  return response.data;
};
